export default "__VITE_ASSET__B2W8UawV__"